import { render, staticRenderFns } from "./RecordLabelIndex.vue?vue&type=template&id=b7accf3a"
import script from "./RecordLabelIndex.vue?vue&type=script&lang=js"
export * from "./RecordLabelIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports